import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const useTotalSpoolCirculatingSupply = () => {
    const { interfaceSDK } = useContext(appContext);

    const { data, error } = useSWR(
        interfaceSDK ? 'totalSpoolCirculatingSupply' : null,
        () => interfaceSDK!.get.getSpoolCirculatingSupply()
    );

    return {
        totalSpoolCirculatingSupply: data,
        isLoading: !error && !data,
        error,
    };
};

export default useTotalSpoolCirculatingSupply;
